import { render, staticRenderFns } from "./video-manage.vue?vue&type=template&id=785b4adf&"
import script from "./video-manage.vue?vue&type=script&lang=js&"
export * from "./video-manage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports